<a *ngIf="thumbnailUrl" href="{{href}}" target="{{target}}" (click)="click()">
    <!-- For local setup -->
    <img [src]="thumbnailUrl | secure | async"  (error)="onImgError($event)"> 

    <!-- While giving build -->
    <!-- <img [src]="thumbnailUrl" alt=""> -->
</a>

<!-- For local setup -->
<img *ngIf="thumbnailUrl && !href" [src]="thumbnailUrl | secure | async"  (error)="onImgError($event)">

<!-- While giving build -->
<!-- <img *ngIf="thumbnailUrl && !href" [src]="thumbnailUrl" alt=""> -->